import React from "react";
import MissingPage from "../pages/MissingPage/MissingPage";

export class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.log('APP ERROR BOUNDARY: ', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return <MissingPage />
    }
    return this.props.children;
  }
}
